var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dynamic-form-container',{attrs:{"scopes":_vm.scopes,"should-notify":true},on:{"onSubmitSuccess":_vm.onSuccess}})}
var staticRenderFns = []

export { render, staticRenderFns }